import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'
import { motion } from 'framer-motion'
import {DarkTheme} from './Themes';

import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'
import astronaut from '../assets/Images/boy.png'

const pageTransition = {
  initial: { opacity: 0, y: 14 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -12,
    transition: { duration: 0.3, ease: "easeIn" },
  },
};

const Box = styled(motion.main)`
  background-color: ${props => props.theme.body};
  width: 100vw;
  min-height:100vh;
  position: relative;
  overflow: hidden;
`

const Content = styled.section`
  width: min(92vw, 78rem);
  min-height: 100vh;
  margin: 0 auto;
  padding: 7.25rem 1rem 2rem 4.5rem;
  display: grid;
  grid-template-columns: minmax(20rem, 1.2fr) minmax(11rem, 0.7fr);
  align-items: center;
  gap: clamp(1rem, 5vw, 5rem);
  position: relative;
  z-index: 2;

  @media (max-width: 64em) {
    padding-left: 2.5rem;
  }

  @media (max-width: 50em) {
    grid-template-columns: 1fr;
    justify-items: center;
    padding: 7.25rem 1rem 2rem;
  }
`

const float = keyframes`
  0% { transform: translateY(-8px); }
  50% { transform: translateY(12px) translateX(10px); }
  100% { transform: translateY(-8px); }
`

const Spaceman = styled.div`
  width: clamp(12rem, 20vw, 18rem);
  animation: ${float} 4s ease infinite;

  img{
    width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 50em) {
    width: clamp(9rem, 42vw, 13rem);
    order: -1;
    opacity: 0.9;
  }

  @media (prefers-reduced-motion: reduce){
    animation: none;
  }
`

const Main =  styled.article`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: clamp(1.25rem, 2vw, 2rem);
  width: 100%;
  max-width: 47rem;
  line-height: 1.65;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: clamp(1rem, 0.75rem + 0.5vw, 1.2rem);
  backdrop-filter: blur(4px);
  font-family: 'Ubuntu Mono', monospace;

  p{
    margin: 0;
  }
`

const AboutPage = () => {
    return (
        <ThemeProvider theme={DarkTheme}>
          <Box variants={pageTransition} initial="initial" animate="animate" exit="exit">
            <LogoComponent theme='dark'/>
            <SocialIcons theme='dark'/>
            <PowerButton />
            <ParticleComponent theme='dark' />

            <Content>
              <Main>
                <p>
                  I am a passionate and results-oriented developer focused on full-stack web
                  development and product thinking.
                </p>
                <p>
                  Building real-world applications has given me a strong foundation in core
                  programming principles, scalable architecture, and user-centered design.
                </p>
                <p>
                  I am always looking for opportunities to solve meaningful problems and
                  contribute to impactful products.
                </p>
              </Main>

              <Spaceman>
                <img src={astronaut} alt="spaceman" />
              </Spaceman>
            </Content>

            <BigTitle text="ABOUT" top="8%" left="4%" />
          </Box>
        </ThemeProvider>
    )
}

export default AboutPage
